<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer005">
<h2 class="fmh" id="_idParaDest-1"><a id="_idTextAnchor000"></a><a href="#/text/9780062859426_Contents#r_idParaDest-1"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">Dedication</span></span></a></h2>
<p class="dedi">T<span class="smallcaps">O</span> L<span class="smallcaps">UKAS AND</span> M<span class="smallcaps">ILLA, ALWAYS</span></p>
</div>
<div>
<div id="_idContainer006">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062859426_Dedication.vue?e637988a